<template>
  <div style="background-color: #fe818c">
    <Header />
    <div class="flex-wrapper">
      <router-view :key="$route.fullPath" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default {
  name: "StandardLayout",
  components: {
    Header,
    Footer
  },

  data() {
    return {
      isLoading: true,
      currentUrl: "",
      prevRoute: ""
    };
  },
  watch: {
    $route(pathUrl) {
      this.currentUrl = pathUrl.path;
      this.isLoading = true;
      /* setTimeout(() => {
        this.isLoading = false;
      }, 1500); */
    }
  },
  mounted() {
    this.currentUrl = window.location.pathname;
    /* -- what was this for?
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
     */
  }
};
</script>

<style>
.flex-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}
</style>
